import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const TABS = [
  { id: "cgu", label: "CGU" },
  { id: "privacy", label: "Confidentialité" },
];

function CGU() {
  return (
    <div className="space-y-5 text-[13.5px] text-gray-600 font-semibold leading-relaxed">
      <p className="text-[11px] text-app-muted">Dernière mise à jour : 2 avril 2026</p>

      <section>
        <h3 className="font-black text-[15px] text-app-text mb-2">1. Objet</h3>
        <p>Les présentes Conditions Générales d'Utilisation (CGU) régissent l'accès et l'utilisation de l'application PawCare, accessible à l'adresse pawcare.vet et en tant qu'application web progressive (PWA).</p>
        <p className="mt-1.5">PawCare est un service d'assistance vétérinaire par intelligence artificielle destiné aux propriétaires d'animaux de compagnie.</p>
      </section>

      <section>
        <h3 className="font-black text-[15px] text-app-text mb-2">2. Éditeur</h3>
        <p>PawCare est édité par :</p>
        <ul className="list-none mt-1.5 space-y-0.5">
          <li><strong>Société :</strong> EI Stéphane Juffé</li>
          <li><strong>Responsable :</strong> Stéphane Juffé</li>
          <li><strong>Adresse :</strong> 53, rue de l'Échiquier — 75010 Paris, France</li>
          <li><strong>Email :</strong> corpus@stephanejuffe.com</li>
        </ul>
      </section>

      <section>
        <h3 className="font-black text-[15px] text-app-text mb-2">3. Accès au service</h3>
        <p>L'inscription est gratuite et ouverte à toute personne physique âgée d'au moins 16 ans. L'utilisateur s'engage à fournir des informations exactes lors de l'inscription et à maintenir la confidentialité de ses identifiants.</p>
        <p className="mt-1.5">PawCare se réserve le droit de suspendre ou supprimer tout compte en cas de non-respect des présentes CGU.</p>
      </section>

      <section>
        <h3 className="font-black text-[15px] text-app-text mb-2">4. Description du service</h3>
        <p>PawCare propose :</p>
        <ul className="list-disc pl-5 mt-1.5 space-y-1">
          <li>Des consultations vétérinaires assistées par intelligence artificielle (Claude, Anthropic)</li>
          <li>Un suivi santé et un carnet vaccinal pour vos animaux</li>
          <li>Des missions de bien-être et de prévention personnalisées</li>
          <li>Des notifications de rappel (vaccins, soins)</li>
        </ul>
      </section>

      <section>
        <h3 className="font-black text-[15px] text-app-text mb-2">5. Avertissement médical</h3>
        <div className="bg-severity-yellow-bg border-[1.5px] border-yellow-300 rounded-2xl px-4 py-3">
          <p className="font-black text-[13px] text-yellow-800 mb-1">Important</p>
          <p className="text-[12.5px] text-yellow-700">PawCare est un outil d'information et d'aide à la décision. Il ne remplace en aucun cas l'avis d'un vétérinaire diplômé. En cas d'urgence ou de symptômes graves, consultez immédiatement un vétérinaire.</p>
          <p className="text-[12.5px] text-yellow-700 mt-1">Les réponses générées par l'IA sont fournies à titre indicatif et peuvent contenir des erreurs. PawCare ne saurait être tenu responsable des décisions prises sur la base de ces informations.</p>
        </div>
      </section>

      <section>
        <h3 className="font-black text-[15px] text-app-text mb-2">6. Version Alpha</h3>
        <p>PawCare est actuellement en version alpha. Le service est fourni « en l'état », sans garantie de disponibilité, de continuité ou d'exactitude. Des bugs, interruptions ou pertes de données peuvent survenir. L'utilisateur en est informé et accepte ces limitations.</p>
      </section>

      <section>
        <h3 className="font-black text-[15px] text-app-text mb-2">7. Propriété intellectuelle</h3>
        <p>L'ensemble des éléments composant PawCare (code, design, textes, logos, icônes) sont la propriété exclusive de EI Stéphane Juffé, sauf mention contraire. Toute reproduction, modification ou distribution sans autorisation est interdite.</p>
      </section>

      <section>
        <h3 className="font-black text-[15px] text-app-text mb-2">8. Contenu utilisateur</h3>
        <p>L'utilisateur conserve la propriété de ses données (fiches animaux, photos, conversations). En utilisant PawCare, il accorde une licence limitée d'utilisation de ces données aux seules fins de fonctionnement du service.</p>
        <p className="mt-1.5">L'utilisateur s'engage à ne pas utiliser le service pour diffuser du contenu illicite, offensant ou contraire aux bonnes mœurs.</p>
      </section>

      <section>
        <h3 className="font-black text-[15px] text-app-text mb-2">9. Tarification</h3>
        <p>PawCare est actuellement gratuit. Des fonctionnalités premium (PawCare Pro) pourront être proposées à l'avenir. Tout changement de tarification sera communiqué à l'avance aux utilisateurs.</p>
      </section>

      <section>
        <h3 className="font-black text-[15px] text-app-text mb-2">10. Limitation de responsabilité</h3>
        <p>PawCare ne saurait être tenu responsable :</p>
        <ul className="list-disc pl-5 mt-1.5 space-y-1">
          <li>Des conséquences de décisions prises sur la base des informations fournies par l'IA</li>
          <li>Des interruptions de service, pertes de données ou dysfonctionnements</li>
          <li>De l'utilisation frauduleuse du compte par un tiers</li>
        </ul>
      </section>

      <section>
        <h3 className="font-black text-[15px] text-app-text mb-2">11. Modification des CGU</h3>
        <p>PawCare se réserve le droit de modifier les présentes CGU à tout moment. Les utilisateurs seront informés par notification ou par email. La poursuite de l'utilisation du service vaut acceptation des nouvelles conditions.</p>
      </section>

      <section>
        <h3 className="font-black text-[15px] text-app-text mb-2">12. Droit applicable</h3>
        <p>Les présentes CGU sont régies par le droit français. En cas de litige, les tribunaux de Paris seront seuls compétents, après tentative de résolution amiable.</p>
      </section>
    </div>
  );
}

function Privacy() {
  return (
    <div className="space-y-5 text-[13.5px] text-gray-600 font-semibold leading-relaxed">
      <p className="text-[11px] text-app-muted">Dernière mise à jour : 2 avril 2026</p>

      <section>
        <h3 className="font-black text-[15px] text-app-text mb-2">1. Responsable du traitement</h3>
        <ul className="list-none space-y-0.5">
          <li><strong>Société :</strong> EI Stéphane Juffé</li>
          <li><strong>Responsable :</strong> Stéphane Juffé</li>
          <li><strong>Adresse :</strong> 53, rue de l'Échiquier — 75010 Paris, France</li>
          <li><strong>Email DPO :</strong> corpus@stephanejuffe.com</li>
        </ul>
      </section>

      <section>
        <h3 className="font-black text-[15px] text-app-text mb-2">2. Données collectées</h3>
        <p>Nous collectons les données suivantes :</p>

        <div className="mt-2 space-y-2.5">
          <div className="bg-gray-50 rounded-xl px-3.5 py-2.5">
            <div className="font-black text-[13px] text-app-text">Données de compte</div>
            <div className="text-[12px] text-app-muted mt-0.5">Nom, adresse email, mot de passe (chiffré)</div>
          </div>
          <div className="bg-gray-50 rounded-xl px-3.5 py-2.5">
            <div className="font-black text-[13px] text-app-text">Données animaux</div>
            <div className="text-[12px] text-app-muted mt-0.5">Nom, espèce, race, date de naissance, poids, antécédents médicaux, vaccins, photos, vétérinaire traitant, numéro de puce</div>
          </div>
          <div className="bg-gray-50 rounded-xl px-3.5 py-2.5">
            <div className="font-black text-[13px] text-app-text">Données de consultation</div>
            <div className="text-[12px] text-app-muted mt-0.5">Conversations avec l'IA, symptômes décrits, diagnostics suggérés</div>
          </div>
          <div className="bg-gray-50 rounded-xl px-3.5 py-2.5">
            <div className="font-black text-[13px] text-app-text">Données techniques</div>
            <div className="text-[12px] text-app-muted mt-0.5">Abonnements push (endpoint navigateur), avis/feedback, données d'utilisation anonymisées</div>
          </div>
        </div>
      </section>

      <section>
        <h3 className="font-black text-[15px] text-app-text mb-2">3. Finalités du traitement</h3>
        <ul className="list-disc pl-5 space-y-1">
          <li>Fournir le service de consultation vétérinaire par IA</li>
          <li>Gérer les comptes utilisateurs et l'authentification</li>
          <li>Stocker et afficher les fiches santé de vos animaux</li>
          <li>Envoyer des notifications de rappel (vaccins, soins)</li>
          <li>Améliorer le service grâce aux retours utilisateurs</li>
        </ul>
      </section>

      <section>
        <h3 className="font-black text-[15px] text-app-text mb-2">4. Base légale</h3>
        <ul className="list-disc pl-5 space-y-1">
          <li><strong>Exécution du contrat :</strong> fourniture du service (compte, consultations, fiches animaux)</li>
          <li><strong>Consentement :</strong> notifications push, partage de données anonymisées</li>
          <li><strong>Intérêt légitime :</strong> sécurité du service, amélioration du produit</li>
        </ul>
      </section>

      <section>
        <h3 className="font-black text-[15px] text-app-text mb-2">5. Sous-traitants et transferts</h3>
        <p>Vos données sont traitées par les sous-traitants suivants, tous situés dans l'Union Européenne ou offrant des garanties adéquates :</p>
        <div className="mt-2 space-y-2">
          <div className="bg-gray-50 rounded-xl px-3.5 py-2.5">
            <div className="font-black text-[13px] text-app-text">MongoDB Atlas</div>
            <div className="text-[12px] text-app-muted mt-0.5">Base de données — Hébergement EU (Irlande)</div>
          </div>
          <div className="bg-gray-50 rounded-xl px-3.5 py-2.5">
            <div className="font-black text-[13px] text-app-text">Google Cloud / Firebase</div>
            <div className="text-[12px] text-app-muted mt-0.5">Hébergement application, stockage photos — Région EU (Belgique)</div>
          </div>
          <div className="bg-gray-50 rounded-xl px-3.5 py-2.5">
            <div className="font-black text-[13px] text-app-text">Anthropic (Claude API)</div>
            <div className="text-[12px] text-app-muted mt-0.5">Moteur d'IA pour les consultations — Les conversations sont envoyées à l'API Claude pour générer les réponses. Anthropic ne conserve pas les données au-delà du traitement de la requête (zero data retention)</div>
          </div>
        </div>
        <p className="mt-2">Aucune donnée n'est vendue, louée ou partagée à des fins publicitaires ou commerciales avec des tiers.</p>
      </section>

      <section>
        <h3 className="font-black text-[15px] text-app-text mb-2">6. Durée de conservation</h3>
        <ul className="list-disc pl-5 space-y-1">
          <li><strong>Données de compte :</strong> conservées tant que le compte est actif, puis supprimées sous 30 jours après demande de suppression</li>
          <li><strong>Données animaux et consultations :</strong> conservées tant que le compte est actif</li>
          <li><strong>Abonnements push :</strong> supprimés automatiquement en cas d'expiration ou de désabonnement</li>
          <li><strong>Feedback :</strong> conservé tant que le compte est actif</li>
        </ul>
      </section>

      <section>
        <h3 className="font-black text-[15px] text-app-text mb-2">7. Sécurité</h3>
        <p>Nous mettons en œuvre les mesures suivantes pour protéger vos données :</p>
        <ul className="list-disc pl-5 mt-1.5 space-y-1">
          <li>Mots de passe chiffrés avec bcrypt (jamais stockés en clair)</li>
          <li>Authentification par token JWT avec expiration</li>
          <li>Communications chiffrées en HTTPS/TLS</li>
          <li>Accès aux données restreint par authentification</li>
        </ul>
      </section>

      <section>
        <h3 className="font-black text-[15px] text-app-text mb-2">8. Vos droits (RGPD)</h3>
        <p>Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez des droits suivants :</p>
        <div className="mt-2 space-y-2">
          {[
            { right: "Accès", desc: "Obtenir une copie de vos données personnelles" },
            { right: "Rectification", desc: "Corriger des données inexactes ou incomplètes" },
            { right: "Suppression", desc: "Demander l'effacement de vos données" },
            { right: "Portabilité", desc: "Recevoir vos données dans un format structuré (JSON)" },
            { right: "Opposition", desc: "Vous opposer au traitement de vos données" },
            { right: "Limitation", desc: "Demander la limitation du traitement" },
            { right: "Retrait du consentement", desc: "Retirer votre consentement à tout moment (notifications, etc.)" },
          ].map((r, i) => (
            <div key={i} className="flex gap-2 items-start">
              <span className="text-pawcare-orange font-black text-xs mt-0.5">●</span>
              <div><strong>{r.right} :</strong> {r.desc}</div>
            </div>
          ))}
        </div>
        <p className="mt-2.5">Pour exercer vos droits, contactez-nous à : <strong>corpus@stephanejuffe.com</strong></p>
        <p className="mt-1">Vous pouvez également introduire une réclamation auprès de la CNIL : <strong>www.cnil.fr</strong></p>
      </section>

      <section>
        <h3 className="font-black text-[15px] text-app-text mb-2">9. Cookies</h3>
        <p>PawCare n'utilise pas de cookies de tracking ou publicitaires. Seuls des cookies techniques strictement nécessaires sont utilisés (token d'authentification stocké en localStorage).</p>
      </section>

      <section>
        <h3 className="font-black text-[15px] text-app-text mb-2">10. Mineurs</h3>
        <p>PawCare est destiné aux personnes âgées d'au moins 16 ans. Si vous avez moins de 16 ans, vous devez obtenir le consentement d'un parent ou tuteur légal avant d'utiliser le service.</p>
      </section>

      <section>
        <h3 className="font-black text-[15px] text-app-text mb-2">11. Modifications</h3>
        <p>Cette politique de confidentialité peut être mise à jour. En cas de modification substantielle, les utilisateurs seront informés par notification ou email. La date de dernière mise à jour est indiquée en haut de cette page.</p>
      </section>
    </div>
  );
}

export default function LegalPage() {
  const [searchParams] = useSearchParams();
  const initialTab = searchParams.get("tab") === "privacy" ? "privacy" : "cgu";
  const [tab, setTab] = useState(initialTab);
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-app-gradient animate-fade-in">
      {/* Header */}
      <div className="bg-pawcare-gradient px-6 pb-5 shadow-pawcare" style={{ paddingTop: "max(20px, env(safe-area-inset-top, 20px))" }}>
        <button
          onClick={() => navigate(-1)}
          className="bg-white/[0.22] border-[1.5px] border-white/35 rounded-xl w-9 h-9 flex items-center justify-center cursor-pointer text-lg text-white mb-4"
        >
          {"\u2190"}
        </button>
        <div className="font-display text-[22px] text-white leading-none">
          Mentions légales
        </div>

        {/* Tabs */}
        <div className="flex gap-2 mt-4">
          {TABS.map(t => (
            <button
              key={t.id}
              onClick={() => setTab(t.id)}
              className="px-4 py-2 rounded-xl font-extrabold text-[13px] border-none cursor-pointer transition-all duration-200"
              style={{
                background: tab === t.id ? "rgba(255,255,255,0.9)" : "rgba(255,255,255,0.2)",
                color: tab === t.id ? "#FF7055" : "rgba(255,255,255,0.8)",
              }}
            >
              {t.label}
            </button>
          ))}
        </div>
      </div>

      {/* Content */}
      <div className="px-5 pt-5 pb-10 max-w-[640px] mx-auto">
        <div className="bg-white rounded-[22px] p-5 shadow-soft border-[1.5px] border-black/[0.04]">
          <h2 className="font-display text-xl text-app-text mb-4">
            {tab === "cgu" ? "Conditions Générales d'Utilisation" : "Politique de confidentialité"}
          </h2>
          {tab === "cgu" ? <CGU /> : <Privacy />}
        </div>

        <div className="text-center mt-5">
          <span className="text-[11px] text-app-subtle font-semibold">
            PawCare — Créé par Samuel {"\uD83D\uDC3E"}
          </span>
        </div>
      </div>
    </div>
  );
}
